<template>
  <directory />
</template>
<script>
import Directory from './directory/Directory.vue'

export default {
  name: 'Files',
  components: { Directory },
  data() {
    return {
    }
  },
}
</script>
